import React, { useEffect } from 'react';

import Sidebar from './Sidebar'//import $ from "jquery";

import { Link } from 'react-router-dom';
import MainImg from '../assets/img/reset15.png'


const EmailPin = () => {


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])


    return (
        <div>
            <div className="container">
                <div className="row mt-2">
                    <div className="col-sm-1-my text-center ">
                        <p><a href="" className="text-decoration-none"><i className="fa fa-angle-left fa-angle-left-reg" aria-hidden="true"></i></a></p>
                    </div>
                    <div className="col-sm-11-my text-center ">

                        <h3 className="font-weight-bold signin1-h1 mt-2  ">Email PIN</h3>
                    </div>
                    <div className="col-sm-12 text-center">
                        <img src={MainImg} alt="" srcset="" className="MainImg-s1-reset mt-5" />

                    </div>

                </div>
            </div>
            <div className="  p-4 mt-4" style={{ borderRadius: "25px 25px 0 0", boxShadow: "0 -0.3rem 1rem rgba(0,0,0,.15)" }}>
                <div className="row ">
                    <div className="col-sm-12">
                        <p className="text-center bg-light-st pin2-sm">Your PIN will be sent to your email address associated with your account. Kindly enter the email address and click on Send PIN.</p>
                        <div className="">
                            <form className="reset-form mt-5 ">

                                <div className="form-group">
                                    <label for="exampleInputEmail1">Enter Email Address </label>
                                    <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Email" />
                                </div>

                                <Link to="/Signin2" type="button" className="btn btn-success w-100 fw100 mt-4 py-2">Send PIN</Link>


                            </form>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default EmailPin;